module.exports = __webpack_public_path__ + "static/media/assistenciaSocial.0e72b8f4.svg";